export const MATERIA_TIPO_GRADO = 'Grado';
export const MATERIA_TIPO_ELECTIVA = 'Electiva';

export const MATERIA_TIPO_OPTIONS = [
  { value: MATERIA_TIPO_GRADO, label: 'Materia de grado' },
  { value: MATERIA_TIPO_ELECTIVA, label: 'Materia electiva' }
];

export const normalizeMateriaTipo = (tipoMateria) => {
  if ((tipoMateria || '').toLowerCase() === MATERIA_TIPO_ELECTIVA.toLowerCase()) {
    return MATERIA_TIPO_ELECTIVA;
  }

  return MATERIA_TIPO_GRADO;
};

export const getMateriaTipoLabel = (tipoMateria) => {
  const normalized = normalizeMateriaTipo(tipoMateria);
  const option = MATERIA_TIPO_OPTIONS.find((item) => item.value === normalized);
  return option?.label || normalized;
};
